import React from "react";
import '../styles/FormInput.css';
import { DatePicker } from "antd";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const FormDate = (props) => {
    return (
        <div className="form-input-container">
            <div className="form-label">
                {props.label}{props.mandatory ? <span className="mandatory">*</span> : <></>}
            </div>
            <div className={props.buttonLabel ? "input-field-container margin-r-10" : "input-field-container"}>
                <DatePicker format="DD-MM-YYYY" maxDate={props.maxDate ? dayjs(props.maxDate, "DD-MM-YYYY") : null} value={props.value ? dayjs(props.value, "DD-MM-YYYY") : null} onChange={(value,svalue)=>{props.onchange(svalue)}}/>
            </div>
        </div>
    )
}
export default FormDate;